import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
    spaceBetween: 20,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            spaceBetween: 20,
            slidesPerView: 4,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 3,
            spaceBetween: 14,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            spaceBetween: 14,
        }
    },
    
});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});


$(".faq-list li").click(function() {
    $(this).toggleClass("active");
    $(this).find(".answer").slideToggle();
})

